import React from 'react';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput
} from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import GroupNameNotice from '@modules/digital-signage/components/group-settings/components/group-devices/components/group-details-fields/components/group-name-notice/group-name-notice.tsx';
import { useErrorMessage } from '@hooks/use-error-message.ts';
import { validateNotOnlySpaces } from '@utils/trim-form-values-utils.ts';
import { deviceGroupErrorMessages } from '@modules/digital-signage/utils/digital-signage.utils.ts';
import {
  GroupDetailsFieldsProps,
  GroupSettingsFormValues
} from '@modules/digital-signage/model/group-settings.model.ts';

const GroupDetailsFields: React.FC<GroupDetailsFieldsProps> = ({
  isDefaultGroup,
  hasGroupName,
  addedDevicesCount
}) => {
  const { t } = useTranslation();
  const getErrorMessage = useErrorMessage();
  const {
    register,
    formState: { errors }
  } = useFormContext<GroupSettingsFormValues>();

  return (
    <FormControl fullWidth error={!!errors.groupName}>
      <FormLabel className="flex">
        {!isDefaultGroup && <span className="reuqired-symbole">*</span>}
        {t('label_digital_signage_group_name')}
      </FormLabel>
      <OutlinedInput
        {...register('groupName', {
          required: !isDefaultGroup,
          validate: isDefaultGroup
            ? undefined
            : { notOnlySpaces: validateNotOnlySpaces }
        })}
        error={!!errors.groupName}
        placeholder={t('placeholder_name')}
      />
      {!isDefaultGroup && (
        <FormHelperText>
          {errors.groupName &&
            getErrorMessage({
              errors,
              fieldName: 'groupName',
              errorMessages: { groupName: deviceGroupErrorMessages.name }
            })}
        </FormHelperText>
      )}
      <GroupNameNotice
        isDefaultGroup={isDefaultGroup}
        hasGroupName={hasGroupName}
        addedDevicesCount={addedDevicesCount}
      />
    </FormControl>
  );
};

export default GroupDetailsFields;
